import { useState } from "react";
import CRMTable from "./CRMTable";

export default function CRMPage() {
  const allFunnels = [
    {
      id: "1",
      name: "Vendas",
      stages: ["Prospecção", "Contato", "Proposta", "Fechamento"],
      data: {
        Prospecção: [],
        Contato: [],
        Proposta: [],
        Fechamento: [],
      },
    },
    {
      id: "2",
      name: "Suporte",
      stages: ["Recebido", "Análise", "Resolvido"],
      data: {
        Recebido: [],
        Análise: [],
        Resolvido: [],
      },
    },
  ];

  const [funnelId, setFunnelId] = useState(allFunnels[0]?.id); // 👈 aqui está o valor padrão
  const currentFunnel = allFunnels.find((f) => f.id === funnelId);

  return <CRMTable funnel={currentFunnel} setFunnelId={setFunnelId} />;
}
